import { APP_PERMISSIONS } from '@exam-center/permission';
import { useHasPermission } from '@shared/permissions';

import { ExamCenterProctorDetailsFormProvider, useExamCenterProctorDetails } from '../../providers';
import { getExamCenterProctorDetailsDefaultValues } from '../../utils';
import { ExamCenterProctorDetailsEditFormLogic } from '../exam-center-proctor-details-edit-form-logic';
import { ExamCenterProctorDetailsReadonlyFields } from '../exam-center-proctor-details-readonly-fields';

export default function ExamCenterProctorDetailsByPermission() {
  const { proctor } = useExamCenterProctorDetails();
  const hasUpdatePermission = useHasPermission(APP_PERMISSIONS.PROCTOR_MANAGEMENT.PROCTOR.UPDATE);

  if (hasUpdatePermission) {
    return (
      <ExamCenterProctorDetailsFormProvider
        initialValues={getExamCenterProctorDetailsDefaultValues({ proctor })}
      >
        <ExamCenterProctorDetailsEditFormLogic />
      </ExamCenterProctorDetailsFormProvider>
    );
  }

  return <ExamCenterProctorDetailsReadonlyFields />;
}
